import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
import { ExportWorkspaceOrProjects } from "@pages/settings/export-workspace/export-workspace-or-project";
import { appStateSelector } from "@store/app/app-selector";
import { useAppSelector } from "@store/store-helper";
import { selectedProjectSelector } from "@store/projects/projects-selector";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";

/**
 * Component to show the section to export the project data in project settings page.
 * The visibility of this section is based on the project features and company level permissions.
 * If the user doesn't have the required permissions or features, this component will return null and won't be rendered in the UI.
 * Hidden while the Sphere Vault beta flag is enabled: the Download action replaces this
 * flow for a single project.
 */
export function ExportProjectData() {
  const $ = _c(3);
  const {
    canExportProject
  } = useHasValidFeatureProjectLevel();
  const selectedProject = useAppSelector(selectedProjectSelector);
  const {
    canExportWorkspace
  } = useHasUserValidRoleCompanyLevel();
  const {
    isBetaTestingEnabled
  } = useAppSelector(appStateSelector);
  if (!canExportProject || !canExportWorkspace || !selectedProject || isBetaTestingEnabled) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mt: "40px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== selectedProject.id) {
    t1 = <Box component="div" sx={t0}><ExportWorkspaceOrProjects entityName="project" projectIds={[selectedProject.id]} /></Box>;
    $[1] = selectedProject.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}